import { ViewContainerRef } from '@angular/core';

export class IDesignerFactoryService {
    create(typeName: string, container: ViewContainerRef): any {
        return null;
    }
}


// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/services/designer-factory-interface.ts